// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

function ArticleHeaderCompo({ article }) {
  return (
    <MKBox mb={5}>
      <Grid container>
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderBottomLeftRadius: 100,
          }}
          item
          py={{ xs: 5, lg: 2 }}
          xs={12}
          lg={6}
          bgcolor='warning.main'
        >
          <Container>
            <MKTypography
              sx={{ alignSelf: 'center' }}
              textGradient
              color='black'
              variant='h2'
            >
              {article.title}
            </MKTypography>
          </Container>
        </Grid>
        <Grid item xs={12} lg={6}>
          <img
            src={article.headerImage}
            alt={article.title}
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              borderBottomRightRadius: 100,
            }}
          />
        </Grid>
      </Grid>
    </MKBox>
  );
}

export default ArticleHeaderCompo;
